import { Button, Divider } from '@ds';
import React from 'react';

interface AssignmentActionsFooterProps {
  onClose: () => void;
  onConfirm: () => void;
  isConfirmDisabled: boolean;
  isLoading: boolean;
}

export const AssignmentActionsFooter: React.FC<AssignmentActionsFooterProps> = ({
  onClose,
  onConfirm,
  isConfirmDisabled,
  isLoading,
}) => (
  <>
    <Divider />
    <div className="flex gap-3 justify-end">
      <Button className="h-9 w-32" variant="outline" onPress={onClose}>
        Discard
      </Button>
      <Button
        className="h-9 w-32"
        isDisabled={isConfirmDisabled}
        isLoading={isLoading}
        variant="solid"
        onPress={onConfirm}
      >
        Confirm
      </Button>
    </div>
  </>
);
